import SwalReact from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const Swal = withReactContent(SwalReact)

export const showSuccess = (alert: any) => {
    Swal.fire({
        title: '',
        color: 'var(--kt-input-color)',
        text: alert.message,
        icon: 'success',
        confirmButtonText: 'Ok, got it!',
        confirmButtonColor:"#00A3FF",
        background: "var(--bs-light)"
    })
}
